export const SET_TOP_BAR_NAVIGATION = "SET_TOP_BAR_NAVIGATION";
export const CLEAR_TOP_BAR_NAVIGATION = "CLEAR_TOP_BAR_NAVIGATION";

export function setTopBarNavigation(display, routeUrl) {
    return {type:SET_TOP_BAR_NAVIGATION, info: { display : display, routeUrl: routeUrl}};
}

export function clearTopBarNavigation() {
    return {type:CLEAR_TOP_BAR_NAVIGATION};
}
